import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type CircleContactInfoProps = {
    className?: string;
};

const CircleContactInfo: FunctionComponent<CircleContactInfoProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'circle-contact-info'}
            viewBox="0 0 250 250"
        >
            <path d="M124.7-.3C55.8-.3-.2 55.8-.2 124.6s56 124.9 124.9 124.9 124.9-56 124.9-124.8c0-68.9-56.1-125-124.9-125zm0 240.8c-63.9 0-115.9-52-115.9-115.9S60.8 8.7 124.7 8.7c63.9 0 115.9 52 115.9 116 0 63.9-52 115.8-115.9 115.8z" />
            <path d="M129.4 154.8c-1.3-8.2-6.9-12.4-10-13.6l-11.2-4.5-7.6-3.4c-1.8-.8-2.4-1.9-2.5-2.3v-.1l.1-.1.6-.6c6.2-7.5 7.5-16.4 7.6-17.4 3.1-22-8.4-28.5-10.5-29.5-3.9-2-8.1-3-12.3-3-7.2 0-12.3 2.8-12.9 3.2-13 7.9-10.2 27.4-10 29 1.4 10.2 7.4 17.4 7.7 17.7l.1.1.5.5c-.4 1.4-1.5 2.1-1.8 2.2l-6 2.6-13.9 5.6c-5.5 2-7.7 6.8-8.1 7.9-1.8 4-2.4 12.9-2.6 15.6l-.3 4.8h4.8c15.9.1 31.9.1 47.4.1 23 0 37.2-.1 37.4-.1h4.8l-1.1-14.4-.2-.3zm-41.1 6c-13.9 0-28.2 0-42.5-.1.4-3.4.9-6.7 1.4-7.8l.1-.3s.9-2.1 2.9-2.8l14.2-5.7 5.9-2.6c1.1-.4 5.9-2.7 7.3-8.8l.1-.3c.1-.9.3-3.2-.6-5.1-.7-1.3-1-1.7-2-2.9-.4-.5-4.6-5.8-5.5-13v-.1c0-.1-2.2-15.1 5.7-19.9.4-.2 3.7-1.9 8.3-1.9 2.9 0 5.7.7 8.3 2l.4.2c.1 0 7.5 3.7 5.2 20v.1c0 .1-.9 7.1-5.6 12.7-.1.1-.1.2-.2.2-.5.6-1.4 1.5-2 2.7l-.2.4c-.2.6-.9 2.7-.1 5.3.4 1.4 1.9 5.9 7.6 8.4l7.6 3.5 11.5 4.6s3.5 1.5 4.3 6.5l.3 4.6c-5.9 0-17.2.1-32.4.1z" />
            <rect width="66.7" height="9" x="144.3" y="97.9" />
            <rect width="66.7" height="9" x="144.3" y="121.6" />
            <rect width="66.7" height="9" x="144.3" y="145.3" />
        </svg>
    );
};
export default CircleContactInfo;
